<h3>Member Details</h3>
<nz-table nzBordered [nzShowPagination]="false" class="mt-2" [nzData]="[0]" [nzSize]="'small'">
	<thead>
		<tr>
			<th style="width: 200px;">Field</th>
			<th>Value</th>
		</tr>
	</thead>
	<tbody>
		<tr><td><strong>ID Number</strong></td><td>{{ member.idNumber }}</td></tr>
		<tr><td><strong>Date Of Birth</strong></td><td>{{ member.dateOfBirth | date: 'mediumDate' }}</td></tr>
		<tr><td><strong>Name</strong></td><td>{{ member.name }}</td></tr>
		<tr><td><strong>Surname</strong></td><td>{{ member.surname }}</td></tr>
		<tr><td><strong>Email Address</strong></td><td>{{ member.emailAddress }}</td></tr>
		<tr><td><strong>Phone Number</strong></td><td>{{ member.msisdn }}</td></tr>
	</tbody>
</nz-table>

<nz-descriptions [nzColumn]="{ xxl: 6, xl: 4, lg: 4, md: 3, sm: 2, xs: 1 }" nzLayout="vertical" nzBordered class="mt-2">
	<nz-descriptions-item *ngFor="let property of getDynamicProperties(member.properties)" [nzTitle]="property">{{member.properties[property]}}</nz-descriptions-item>
</nz-descriptions>

<ng-container *ngIf="member.dependants.length>1">
	<h3>Dependants</h3>

	<ng-container *ngFor="let dependant of member.dependants; let i=index">
		Dependant #{{i+1}}
		<nz-table nzBordered [nzShowPagination]="false" class="mt-2" [nzData]="[0]" [nzSize]="'small'">
			<thead>
				<tr>
					<th style="width: 200px;">Field</th>
					<th>Value</th>
				</tr>
			</thead>
			<tbody>
				<tr><td><strong>ID Number</strong></td><td>{{ dependant.idNumber }}</td></tr>
				<tr><td><strong>Date Of Birth</strong></td><td>{{ dependant.dateOfBirth | date: 'mediumDate' }}</td></tr>
				<tr><td><strong>Name</strong></td><td>{{ dependant.name }}</td></tr>
				<tr><td><strong>Surname</strong></td><td>{{ dependant.surname }}</td></tr>
				<tr><td><strong>Relationship</strong></td><td>{{ dependant.relationship }}</td></tr>
				<tr><td><strong>Email Address</strong></td><td>{{ dependant.emailAddress }}</td></tr>
				<tr><td><strong>Phone Number</strong></td><td>{{ dependant.msisdn }}</td></tr>
			</tbody>
		</nz-table>
		<nz-descriptions [nzColumn]="{ xxl: 6, xl: 4, lg: 4, md: 3, sm: 2, xs: 1 }" nzLayout="vertical" nzBordered class="mt-2">
			<nz-descriptions-item *ngFor="let property of getDynamicProperties(dependant.properties)" [nzTitle]="property">{{dependant.properties[property]}}</nz-descriptions-item>
		</nz-descriptions>
	</ng-container>
</ng-container>
